// https://stackoverflow.com/a/34209399/7027045
export default function toQueryString(obj = {}) {
	const query = Object.keys(obj)
		.map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
		.join('&');

	return `?${query}`;
}
